import { useState, useEffect } from "react";
import { G } from "./shared/styles";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";

export default function App() {
  const [page, setPage] = useState(() => {
    // Check if user is already logged in
    const token = localStorage.getItem("token");
    return token ? "dash" : "land";
  });

  useEffect(() => {
    const s = document.createElement("style");
    s.textContent = G;
    document.head.appendChild(s);
    return () => document.head.removeChild(s);
  }, []);

  const handleNav = (p) => {
    if (p === "land" || p === "login") {
      // Clear session on logout
      if (page === "dash") {
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("email");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("full_name");
        localStorage.removeItem("company_id");
        localStorage.removeItem("company_name");
        localStorage.removeItem("branch_id");
        localStorage.removeItem("branch_name");
        localStorage.removeItem("role_id");
        localStorage.removeItem("role_name");
        localStorage.removeItem("permissions");
      }
    }
    setPage(p);
  };

  return (
    <>
      {page === "land" && <LandingPage go={handleNav} />}
      {page === "login" && <LoginPage go={handleNav} />}
      {page === "dash" && <DashboardPage go={handleNav} />}
    </>
  );
}
